import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useListCampaignMappingsQuery } from "../../redux/api/campaignMappings";
import { Select } from "antd";
import { setSelectedDropdownValues } from "../../redux/store/genericReportingSlice";

const CampaignMappingDropdown = () => {

    const dispatch = useDispatch();
    const selectedClient = useSelector((state) => state.genericReporting.selectedDropdownValues['client_name']);
    const selectedClientRegion = 'ALL';
    const selectedCampaignMappingConfigName = useSelector((state) => state.genericReporting.selectedDropdownValues['campaign_mapping_config_name'] || '');

    const listCampaignMappings = useListCampaignMappingsQuery({ clientName: selectedClient, clientRegion: selectedClientRegion });
    
    return (
        <Select
            style={{ width: "10vw" }}
            value={selectedCampaignMappingConfigName}
            onChange={(value) => dispatch(setSelectedDropdownValues({ dropdownName: 'campaign_mapping_config_name', value }))}
            options={
            listCampaignMappings.data?.map((campaignMapping) => ({
                label: campaignMapping.config_name,
                value: campaignMapping.config_name
            }))
        }
        />
    );
}

export default CampaignMappingDropdown;